import styled from 'styled-components';

export const Styled = styled.div`
  .ant-input-group-wrapper {
    border: none;
    .ant-input-affix-wrapper {
      height: 60px;

      border-right: none;
    }
    .ant-input-group-addon {
      padding: 0;
      > .Button {
        height: 60px;
        width: 100%;
      }
    }
  }
`;
